import { render } from "./IconCross-b1.5_w8_h8_grey.vue?vue&type=template&id=1d20f8d5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__